<ng-container *ngIf="hasPolicies">
  <div class="activitiesPolicies__cont">
    <div class="activitiesPolicies__header">
      <app-ds-typography
        [tag]="'h2'"
        [size]="isUserHistory ? fontSize.RG : fontSize.XS"
        [color]="fontColor.Primary"
        [fontFamily]="fontFamily.SemiBold"
        [text]="'BOOKING_MODULE.CANCELLATION_POLICIES' | transloco">
      </app-ds-typography>
      <div class="activitiesPolicies__header-description" [class.is-user-history]="isUserHistory">
        <app-ds-typography
          [tag]="'h3'"
          [size]="fontSize.XXS"
          [color]="fontColor.Primary"
          [fontFamily]="fontFamily.Regular"
          [text]="'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.ACTIVITIES_POLICIES.DESCRIPTION' | transloco">
        </app-ds-typography>
      </div>
    </div>
    <div class="activitiesPolicies__policies">
      <ng-container *ngFor="let product of products; trackBy: trackById; last as isLast">
        <div class="activitiesPolicies__policies-accordion" [class.last]="isLast">
          <app-ds-accordion
            [type]="accordionType"
            [size]="accordionSize"
            [initState]="!isUserHistory"
            [text]="'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.ACTIVITIES_POLICIES.ACCORDION' | transloco : { name: product.ProductName }">
            <div class="activitiesPolicies__policies-card">
              <app-ds-typography
                [size]="fontSize.XXXS"
                [color]="fontColor.Primary"
                [text]="product.CancellationPolicies">
              </app-ds-typography>
            </div>
          </app-ds-accordion>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>